import type { ReactNode } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

interface QuizLayoutProps {
  children: ReactNode;
  /** show the back chevron in the top-left of the card */
  showBack?: boolean;
  /** widen the card past the default 640px (for /pricing-style side-by-side layouts) */
  wide?: boolean;
  /** Override where the header logo links to. Default: `/`. */
  logoHref?: string;
}

export function QuizLayout({
  children,
  showBack = true,
  wide = false,
  logoHref = '/',
}: QuizLayoutProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const canGoBack = showBack && location.pathname !== '/';

  return (
    <div className="min-h-dvh flex flex-col bg-canvas">
      <header className="px-5 sm:px-10 py-5 max-w-[1200px] w-full mx-auto">
        <a href={logoHref} className="inline-flex items-center text-ink" aria-label="Jobtest.org">
          <img
            src="/jobtestlogo.svg"
            alt="Jobtest.org"
            className="h-7 sm:h-8 w-auto"
            width={319}
            height={76}
          />
        </a>
      </header>

      <main className="flex-1 flex flex-col items-center px-3 sm:px-6 pt-6 pb-12">
        <div className={wide ? 'card card-wide' : 'card'}>
          {canGoBack && (
            <div className="-mt-2 mb-5">
              <button
                type="button"
                onClick={() => navigate(-1)}
                aria-label="Go back"
                className="inline-flex items-center gap-1.5 text-ink-soft hover:text-ink transition px-2 py-1 -ml-2 rounded-md font-medium text-sm"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden
                >
                  <path d="M15 18l-6-6 6-6" />
                </svg>
                Back
              </button>
            </div>
          )}
          {children}
        </div>
      </main>
    </div>
  );
}
